import React from 'react';
import PropTypes from 'prop-types';
import {getResizeImagePaths, onImageError} from '../../../utils';

import {Icon} from '../';

const Avatar = (props) => {
  const {image, imageHeight, imageWidth, fullName, className, iconSize} = props;

  if (image && imageWidth) {
    const {defaultImageURL, resizedImageURL} = getResizeImagePaths(image, imageWidth, imageHeight);

    return (<img
      src={resizedImageURL}
      onError={onImageError(defaultImageURL)}
      alt={fullName}
      className={className}
    />);
  }
  if (image) {
    return <img src={image} alt={fullName} className={className}/>;
  }

  return <Icon glyph="user-circle" iconSize={iconSize}/>;
};

Avatar.propTypes = {
  image: PropTypes.string,
  imageHeight: PropTypes.number,
  imageWidth: PropTypes.number,
  fullName: PropTypes.string,
  className: PropTypes.string,
  iconSize: PropTypes.string,
};

Avatar.defaultProps = {
  image: '',
  imageHeight: 0,
  imageWidth: 0,
  fullName: '',
  className: '',
  iconSize: '',
};

export default Avatar;
